export default "__VITE_ASSET__eb6724ce__"